module.exports = __webpack_public_path__ + "static/suzuki-9a3ee4f553fcfc76e41e6f13b8608afc.png";